// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-result-popup .header[data-v-b1d77184]{text-align:center}.modal-popup[data-v-b1d77184]  .modal{width:420px;padding:47px 0 0!important}.modal-popup[data-v-b1d77184]  .modal h1{text-align:center;font-family:\"Instrument Serif\",Georgia,Times New Roman,serif;font-style:normal;font-weight:400;font-size:28px;line-height:38px}.modal-popup[data-v-b1d77184]  .modal .buttons{padding:28px 0}.modal-popup[data-v-b1d77184]  .modal .buttons button:first-child{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
